import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Button, Container, IconButton, styled } from '@mui/material';
import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from 'react';
import { fetchNewPlanets } from '../api/fetchNewPlanets';
import dayjs from 'dayjs';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { KeyboardDoubleArrowRight, PlayArrowRounded } from '@mui/icons-material';
import { CurvedRightArrow } from './curved-right-arrow';
import { CurvedLeftArrow } from './curved-left-arrow';

export const TransitDayArrow = (props:any) => {

    const StyledButton= styled(IconButton,{})({
        color: 'rgba(0,0,0,70)',
        minPadding:'0',
        justifyContent: 'center',
        ':hover':{
            backgroundColor: 'rgba(222, 241, 247,.70);'
        },
        // "MuiButtonBase-root":{
        //     padding:'0px'
        // }
        })
        
        const StyledContainer= styled(Container,{})({
            
            paddingLeft: '0px',
            paddingRight: '0px',
            paddingTop:'0px',
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            '@media (min-width: 600px)':{
                paddingLeft: '0px',
                paddingRight: '0px',
    
            }
        })

    let varTid = ''

    let MoPlanetX = ""
    let MoPlanetY = ""
    let MoSignX =""
    let MoSignY =""
    let MoDegree = ""
    let MoDegreeX = ""
    let MoDegreeY = ""
    let MoMinute = ""
    let MoMinuteX = ""
    let MoMinuteY = ""
    let MePlanetX = ""
    let MePlanetY = ""
    let MeSignX =""
    let MeSignY =""
    let MeDegree = ""
    let MeDegreeX = ""
    let MeDegreeY = ""
    let MeMinute = ""
    let MeMinuteX = ""
    let MeMinuteY = ""
    let MeRX = ""
    let MeRXX = true
    let MeRXY = ""
    let VePlanetX = ""
    let VePlanetY = ""
    let VeSignX =""
    let VeSignY =""
    let VeDegree = ""
    let VeDegreeX = ""
    let VeDegreeY = ""
    let VeMinute = ""
    let VeMinuteX = ""
    let VeMinuteY = ""
    let VeRX = false
    let VeRXX = ""
    let VeRXY = ""
    let SuPlanetX = ""
    let SuPlanetY = ""
    let SuSignX =""
    let SuSignY =""
    let SuDegree = ""
    let SuDegreeX = ""
    let SuDegreeY = ""
    let SuMinute = ""
    let SuMinuteX = ""
    let SuMinuteY = ""
    let MaPlanetX = ""
    let MaPlanetY = ""
    let MaSignX =""
    let MaSignY =""
    let MaDegree = ""
    let MaDegreeX = ""
    let MaDegreeY = ""
    let MaMinute = ""
    let MaMinuteX = ""
    let MaMinuteY = ""
    let MaRX = false
    let MaRXX = ""
    let MaRXY = ""
    let JuPlanetX = ""
    let JuPlanetY = ""
    let JuSignX =""
    let JuSignY =""
    let JuDegree = ""
    let JuDegreeX = ""
    let JuDegreeY = ""
    let JuMinute = ""
    let JuMinuteX = ""
    let JuMinuteY = ""
    let JuRX = false
    let JuRXX = ""
    let JuRXY = ""
    let SaPlanetX = ""
    let SaPlanetY = ""
    let SaSignX =""
    let SaSignY =""
    let SaDegree = ""
    let SaDegreeX = ""
    let SaDegreeY = ""
    let SaMinute = ""
    let SaMinuteX = ""
    let SaMinuteY = ""
    let SaRX = false
    let SaRXX = ""
    let SaRXY = ""
    let UrPlanetX = ""
    let UrPlanetY = ""
    let UrSignX =""
    let UrSignY =""
    let UrDegree = ""
    let UrDegreeX = ""
    let UrDegreeY = ""
    let UrMinute = ""
    let UrMinuteX = ""
    let UrMinuteY = ""
    let UrRX = false
    let UrRXX = ""
    let UrRXY = ""
    let NePlanetX = ""
    let NePlanetY = ""
    let NeSignX =""
    let NeSignY =""
    let NeDegree = ""
    let NeDegreeX = ""
    let NeDegreeY = ""
    let NeMinute = ""
    let NeMinuteX = ""
    let NeMinuteY = ""
    let NeRX = false
    let NeRXX = ""
    let NeRXY = ""
    let PlPlanetX = ""
    let PlPlanetY = ""
    let PlSignX =""
    let PlSignY =""
    let PlDegree = ""
    let PlDegreeX = ""
    let PlDegreeY = ""
    let PlMinute = ""
    let PlMinuteX = ""
    let PlMinuteY = ""
    let PlRX = false
    let PlRXX = ""
    let PlRXY = ""
    let RaPlanetX = ""
    let RaPlanetY = ""
    let RaSignX =""
    let RaSignY =""
    let RaDegree = ""
    let RaDegreeX = ""
    let RaDegreeY = ""
    let RaMinute = ""
    let RaMinuteX = ""
    let RaMinuteY = ""
    let RaRX = true
    let RaRXX = ""
    let RaRXY = ""
    let KePlanetX = ""
    let KePlanetY = ""
    let KeSignX =""
    let KeSignY =""
    let KeDegree = ""
    let KeDegreeX = ""
    let KeDegreeY = ""
    let KeMinute = ""
    let KeMinuteX = ""
    let KeMinuteY = ""
    let KeRX = true
    let KeRXX = ""
    let KeRXY = ""
    let ChPlanetX = ""
    let ChPlanetY = ""
    let ChSignX =""
    let ChSignY =""
    let ChDegree = ""
    let ChDegreeX = ""
    let ChDegreeY = ""
    let ChMinute = ""
    let ChMinuteX = ""
    let ChMinuteY = ""
    let ChRX = false
    let ChRXX = ""
    let ChRXY = ""
    let ASCPlanetX = ""
    let ASCPlanetY = ""
    let ASCSignX =""
    let ASCSignY =""
    let ASCDegree = ""
    let ASCDegreeX = ""
    let ASCDegreeY = ""
    let ASCMinute = ""
    let ASCMinuteX = ""
    let ASCMinuteY = ""
    let DSCPlanetX = ""
    let DSCPlanetY = ""
    let DSCSignX =""
    let DSCSignY =""
    let DSCDegree = ""
    let DSCDegreeX = ""
    let DSCDegreeY = ""
    let DSCMinute = ""
    let DSCMinuteX = ""
    let DSCMinuteY = ""
    let ICPlanetX = ""
    let ICPlanetY = ""
    let ICSignX =""
    let ICSignY =""
    let ICDegree = ""
    let ICDegreeX = ""
    let ICDegreeY = ""
    let ICMinute = ""
    let ICMinuteX = ""
    let ICMinuteY = ""
    let MCPlanetX = ""
    let MCPlanetY = ""
    let MCSignX =""
    let MCSignY =""
    let MCDegree = ""
    let MCDegreeX = ""
    let MCDegreeY = ""
    let MCMinute = ""
    let MCMinuteX = ""
    let MCMinuteY = ""
 

    let planet = null
    let degree = null
    let sign = null
    let minute = null
    let rx = null
   


    interface ChartInfo  {
    
        utc_date: any;
        signs: any;
        planets: any;
    
  }
  
    async function fetchNewPlanets(direction: string, interval: string, tid: string, lat: string, long: string): Promise<ChartInfo> {
      const response = 
      (process.env.NODE_ENV=='development') ?
      await fetch(`http://localhost:8000/${direction}/${interval}?tid=${tid}&lat=${lat}&long=${long}`)
      :
      await fetch(`https://api.planetgazer.net/${direction}/${interval}?tid=${tid}&lat=${lat}&long=${long}`);
  
      //await fetch(`http://localhost:8000/${direction}/${interval}?tid=${tid}&lat=${lat}&long=${long}`);
      return response.json();
    }
      
    const {data: transits , error, isLoading, isSuccess: SuccessTransit, refetch} = useQuery<ChartInfo>(
      { 
      // placeholderData: "",
      queryKey: ['transits','forward','day',varTid],
      queryFn: () => fetchNewPlanets('forward','day',varTid, props.lat.current, props.long.current),
      enabled: false,
      staleTime: Infinity
  
      });

   
    const handleForwardClick  = async  () => { 

        props.setSelectedSectionType("day");
        // props.dayCount.current -= 
        props.setDefaultDate(props.defaultDate.add(1, 'day'))
        varTid=(dayjs(props.defaultDate).add(1, 'day').toISOString()) 
        props.setAllowedToFetch(false)
        await refetch()
            
       };
    
       const handleBackClick  = async  () => { 

        props.setSelectedSectionType("day");
        // props.dayCount.current -= 
        props.setDefaultDate(props.defaultDate.subtract(1, 'day'))
        varTid=(dayjs(props.defaultDate).subtract(1, 'day').toISOString()) 
        props.setAllowedToFetch(false)
        await refetch()
            
       };


       useEffect(() => {
        if(SuccessTransit){
 
             if (transits !== null || transits !== undefined)
                 {props.tid.current = transits?.utc_date}
             
 
             console.log("ptid:" + props.ptid.current)
             console.log("tid:" + props.tid.current)
 
             console.log(transits)
 
             props.setSignVals({
                 AriSignX: transits?.signs[0].coord[0],
                 AriSignY: transits?.signs[0].coord[1],
                 TauSignX: transits?.signs[1].coord[0],
                 TauSignY: transits?.signs[1].coord[1],
                 GemSignX: transits?.signs[2].coord[0],
                 GemSignY: transits?.signs[2].coord[1],
                 CanSignX: transits?.signs[3].coord[0],
                 CanSignY: transits?.signs[3].coord[1],
                 LeoSignX: transits?.signs[4].coord[0],
                 LeoSignY: transits?.signs[4].coord[1],
                 VirSignX: transits?.signs[5].coord[0],
                 VirSignY: transits?.signs[5].coord[1],
                 LibSignX: transits?.signs[6].coord[0],
                 LibSignY: transits?.signs[6].coord[1],
                 ScoSignX: transits?.signs[7].coord[0],
                 ScoSignY: transits?.signs[7].coord[1],
                 SagSignX: transits?.signs[8].coord[0],
                 SagSignY: transits?.signs[8].coord[1],
                 CapSignX: transits?.signs[9].coord[0],
                 CapSignY: transits?.signs[9].coord[1],
                 AquSignX: transits?.signs[10].coord[0],
                 AquSignY: transits?.signs[10].coord[1],
                 PisSignX: transits?.signs[11].coord[0],
                 PisSignY: transits?.signs[11].coord[1]
         
             })
 
             
             transits?.planets.map((p: any) => { 
 
                 if (p.planet == "Mo") {
                     props.setMoVals({  
                         MoSym:"R", 
                         MoPlanetX: p.coord[0][0],
                         MoPlanetY: p.coord[0][1],
                         MoSign: p.sign,
                         MoSignSym: p.signSymbol,
                         MoSignX: p.coord[2][0],
                         MoSignY: p.coord[2][1],
                         MoDegree: p.degree,
                         MoDegreeX: p.coord[1][0],
                         MoDegreeY: p.coord[1][1],
                         MoMinute: p.minute,
                         MoMinuteX: p.coord[3][0],
                         MoMinuteY: p.coord[3][1],
                     })
                 }
                 if (p.planet == "Me") { 
                     props.setMeVals({
                         MeSym:"S",          
                         MePlanetX: p.coord[0][0],
                         MePlanetY: p.coord[0][1],
                         MeSign: p.sign,
                         MeSignSym: p.signSymbol,
                         MeSignX: p.coord[2][0],
                         MeSignY: p.coord[2][1],
                         MeDegree: p.degree,
                         MeDegreeX: p.coord[1][0],
                         MeDegreeY: p.coord[1][1],
                         MeMinute: p.minute,
                         MeMinuteX: p.coord[3][0],
                         MeMinuteY: p.coord[3][1],
                         MeRX:  p.rx,
                         MeRXX: p.coord[4][0],
                         MeRXY: p.coord[4][1]
                     })
                 }
                 if (p.planet == "Ve") { 
                     props.setVeVals({    
                         VeSym:"T",      
                         VePlanetX: p.coord[0][0],
                         VePlanetY: p.coord[0][1],
                         VeSign: p.sign,
                         VeSignSym: p.signSymbol,
                         VeSignX: p.coord[2][0],
                         VeSignY: p.coord[2][1],
                         VeDegree: p.degree,
                         VeDegreeX: p.coord[1][0],
                         VeDegreeY: p.coord[1][1],
                         VeMinute: p.minute,
                         VeMinuteX: p.coord[3][0],
                         VeMinuteY: p.coord[3][1],
                         VeRX:  p.rx,
                         VeRXX: p.coord[4][0],
                         VeRXY: p.coord[4][1]
                     })
                 }
                 if (p.planet == "Su") { 
                     props.setSuVals({ 
                         SuSym:p.planetSymbol,         
                         SuPlanetX: p.coord[0][0],
                         SuPlanetY: p.coord[0][1],
                         SuSign: p.sign,
                         SuSignSym: p.signSymbol,
                         SuSignX: p.coord[2][0],
                         SuSignY: p.coord[2][1],
                         SuDegree: p.degree,
                         SuDegreeX: p.coord[1][0],
                         SuDegreeY: p.coord[1][1],
                         SuMinute: p.minute,
                         SuMinuteX: p.coord[3][0],
                         SuMinuteY: p.coord[3][1],
                         SuRX: p.coord[4][0],
                         SuRY: p.coord[4][1]
                     })
                 }
                 
                 if (p.planet == "Ma") { 
                     props.setMaVals({
                         MaSym:"U",          
                         MaPlanetX: p.coord[0][0],
                         MaPlanetY: p.coord[0][1],
                         MaSign: p.sign,
                         MaSignSym: p.signSymbol,
                         MaSignX: p.coord[2][0],
                         MaSignY: p.coord[2][1],
                         MaDegree: p.degree,
                         MaDegreeX: p.coord[1][0],
                         MaDegreeY: p.coord[1][1],
                         MaMinute: p.minute,
                         MaMinuteX: p.coord[3][0],
                         MaMinuteY: p.coord[3][1],
                         MaRX: p.rx,
                         MaRXX: p.coord[4][0],
                         MaRXY: p.coord[4][1]
                     })
                 }
                 if (p.planet == "Ju") { 
                     props.setJuVals({ 
                         JuSym:"V",         
                         JuPlanetX: p.coord[0][0],
                         JuPlanetY: p.coord[0][1],
                         JuSign: p.sign,
                         JuSignSym: p.signSymbol,
                         JuSignX: p.coord[2][0],
                         JuSignY: p.coord[2][1],
                         JuDegree: p.degree,
                         JuDegreeX: p.coord[1][0],
                         JuDegreeY: p.coord[1][1],
                         JuMinute: p.minute,
                         JuMinuteX: p.coord[3][0],
                         JuMinuteY: p.coord[3][1],
                         JuRX: p.rx,
                         JuRXX: p.coord[4][0],
                         JuRXY: p.coord[4][1]
                     })
                 }
                 if (p.planet == "Sa") { 
                     props.setSaVals({
                         SaSym:"W",          
                         SaPlanetX: p.coord[0][0],
                         SaPlanetY: p.coord[0][1],
                         SaSign: p.sign,
                         SaSignSym: p.signSymbol,
                         SaSignX: p.coord[2][0],
                         SaSignY: p.coord[2][1],
                         SaDegree: p.degree,
                         SaDegreeX: p.coord[1][0],
                         SaDegreeY: p.coord[1][1],
                         SaMinute: p.minute,
                         SaMinuteX: p.coord[3][0],
                         SaMinuteY: p.coord[3][1],
                         SaRX: p.rx,
                         SaRXX: p.coord[4][0],
                         SaRXY: p.coord[4][1]
                     })
                 }
                 if (p.planet == "Ur") { 
                     props.setUrVals({  
                         UrSym:"X",        
                         UrPlanetX: p.coord[0][0],
                         UrPlanetY: p.coord[0][1],
                         UrSign: p.sign,
                         UrSignSym: p.signSymbol,
                         UrSignX: p.coord[2][0],
                         UrSignY: p.coord[2][1],
                         UrDegree: p.degree,
                         UrDegreeX: p.coord[1][0],
                         UrDegreeY: p.coord[1][1],
                         UrMinute: p.minute,
                         UrMinuteX: p.coord[3][0],
                         UrMinuteY: p.coord[3][1],
                         UrRX: p.rx,
                         UrRXX: p.coord[4][0],
                         UrRXY: p.coord[4][1]
                     })
                 }
                 if (p.planet == "Ne") { 
                     props.setNeVals({  
                         NeSym:"Y",        
                         NePlanetX: p.coord[0][0],
                         NePlanetY: p.coord[0][1],
                         NeSign: p.sign,
                         NeSignSym: p.signSymbol,
                         NeSignX: p.coord[2][0],
                         NeSignY: p.coord[2][1],
                         NeDegree: p.degree,
                         NeDegreeX: p.coord[1][0],
                         NeDegreeY: p.coord[1][1],
                         NeMinute: p.minute,
                         NeMinuteX: p.coord[3][0],
                         NeMinuteY: p.coord[3][1],
                         NeRX: p.rx,
                         NeRXX: p.coord[4][0],
                         NeRXY: p.coord[4][1]
                     })
                 }
                 if (p.planet == "Pl") { 
                     props.setPlVals({   
                         PlSym:"Z",       
                         PlPlanetX: p.coord[0][0],
                         PlPlanetY: p.coord[0][1],
                         PlSign: p.sign,
                         PlSignSym: p.signSymbol,
                         PlSignX: p.coord[2][0],
                         PlSignY: p.coord[2][1],
                         PlDegree: p.degree,
                         PlDegreeX: p.coord[1][0],
                         PlDegreeY: p.coord[1][1],
                         PlMinute: p.minute,
                         PlMinuteX: p.coord[3][0],
                         PlMinuteY: p.coord[3][1],
                         PlRX: p.rx,
                         PlRXX: p.coord[4][0],
                         PlRXY: p.coord[4][1]
                     })
                 }
                 if (p.planet == "Ra") { 
                     props.setRaVals({
                         RaSym:"<",          
                         RaPlanetX: p.coord[0][0],
                         RaPlanetY: p.coord[0][1],
                         RaSign: p.sign,
                         RaSignSym: p.signSymbol,
                         RaSignX: p.coord[2][0],
                         RaSignY: p.coord[2][1],
                         RaDegree: p.degree,
                         RaDegreeX: p.coord[1][0],
                         RaDegreeY: p.coord[1][1],
                         RaMinute: p.minute,
                         RaMinuteX: p.coord[3][0],
                         RaMinuteY: p.coord[3][1],
                         RaRX: p.rx,
                         RaRXX: p.coord[4][0],
                         RaRXY: p.coord[4][1],
                         RXSym: 'M' 
                     })
                 }
                 if (p.planet == "Ke") { 
                     props.setKeVals({ 
                         KeSym:">",         
                         KePlanetX: p.coord[0][0],
                         KePlanetY: p.coord[0][1],
                         KeSign: p.sign,
                         KeSignSym: p.signSymbol,
                         KeSignX: p.coord[2][0],
                         KeSignY: p.coord[2][1],
                         KeDegree: p.degree,
                         KeDegreeX: p.coord[1][0],
                         KeDegreeY: p.coord[1][1],
                         KeMinute: p.minute,
                         KeMinuteX: p.coord[3][0],
                         KeMinuteY: p.coord[3][1],
                         KeRX: p.rx,
                         KeRXX: p.coord[4][0],
                         KeRXY: p.coord[4][1]
                     })
                 }
                 if (p.planet == "Ch") { 
                     props.setChVals({  
                         ChSym:"t",        
                         ChPlanetX: p.coord[0][0],
                         ChPlanetY: p.coord[0][1],
                         ChSign: p.sign,
                         ChSignSym: p.signSymbol,
                         ChSignX: p.coord[2][0],
                         ChSignY: p.coord[2][1],
                         ChDegree: p.degree,
                         ChDegreeX: p.coord[1][0],
                         ChDegreeY: p.coord[1][1],
                         ChMinute: p.minute,
                         ChMinuteX: p.coord[3][0],
                         ChMinuteY: p.coord[3][1],
                         ChRX: p.rx,
                         ChRXX: p.coord[4][0],
                         ChRXY: p.coord[4][1]
                     })
                 }
                 if (p.planet == "ASC") { 
                     props.setASCVals({
                         ASCSym:"a",          
                         ASCPlanetX: p.coord[0][0],
                         ASCPlanetY: p.coord[0][1],
                         ASCSign: p.sign,
                         ASCSignSym: p.signSymbol,
                         ASCSignX: p.coord[2][0],
                         ASCSignY: p.coord[2][1],
                         ASCDegree: p.degree,
                         ASCDegreeX: p.coord[1][0],
                         ASCDegreeY: p.coord[1][1],
                         ASCMinute: p.minute,
                         ASCMinuteX: p.coord[3][0],
                         ASCMinuteY: p.coord[3][1]
                     })
         
                 }
                 if (p.planet == "DSC") { 
                     props.setDSCVals({
                         DSCSym:"DC",          
                         DSCPlanetX: p.coord[0][0],
                         DSCPlanetY: p.coord[0][1],
                         DSCSign: p.sign,
                         DSCSignSym: p.signSymbol,
                         DSCSignX: p.coord[2][0],
                         DSCSignY: p.coord[2][1],
                         DSCDegree: p.degree,
                         DSCDegreeX: p.coord[1][0],
                         DSCDegreeY: p.coord[1][1],
                         DSCMinute: p.minute,
                         DSCMinuteX: p.coord[3][0],
                         DSCMinuteY: p.coord[3][1]
                     })
                 }
                 if (p.planet == "IC") { 
                     props.setICVals({ 
                         ICSym:"c",         
                         ICPlanetX: p.coord[0][0],
                         ICPlanetY: p.coord[0][1],
                         ICSign: p.sign,
                         ICSignSym: p.signSymbol,
                         ICSignX: p.coord[2][0],
                         ICSignY: p.coord[2][1],
                         ICDegree: p.degree,
                         ICDegreeX: p.coord[1][0],
                         ICDegreeY: p.coord[1][1],
                         ICMinute: p.minute,
                         ICMinuteX: p.coord[3][0],
                         ICMinuteY: p.coord[3][1]
                     })
                 }
                 if (p.planet == "MC") { 
                     props.setMCVals({ 
                         MCSym:"b",         
                         MCPlanetX: p.coord[0][0],
                         MCPlanetY: p.coord[0][1],
                         MCSign: p.sign,
                         MCSignSym: p.signSymbol,
                         MCSignX: p.coord[2][0],
                         MCSignY: p.coord[2][1],
                         MCDegree: p.degree,
                         MCDegreeX: p.coord[1][0],
                         MCDegreeY: p.coord[1][1],
                         MCMinute: p.minute,
                         MCMinuteX: p.coord[3][0],
                         MCMinuteY: p.coord[3][1]
                     })
                 }
                 if (p.planet == "LoFo") { 
                    props.setLoFoVals({ 
                        LoFoSym:";",         
                        LoFoPlanetX: p.coord[0][0],
                        LoFoPlanetY: p.coord[0][1],
                        LoFoSign: p.sign,
                        LoFoSignSym: p.signSymbol,
                        LoFoSignX: p.coord[2][0],
                        LoFoSignY: p.coord[2][1],
                        LoFoDegree: p.degree,
                        LoFoDegreeX: p.coord[1][0],
                        LoFoDegreeY: p.coord[1][1],
                        LoFoMinute: p.minute,
                        LoFoMinuteX: p.coord[3][0],
                        LoFoMinuteY: p.coord[3][1]
                    })
                }
                 
                 })
             }
         }
         ,[transits])

   
   
    return <div className="arrow-group">
        <StyledContainer>
            <StyledButton onClick={handleBackClick} aria-label="back">
                <CurvedLeftArrow  width='1rem' height='1rem' fill = 'rgb(77, 77, 77)'
 />   
            </StyledButton>
            <div className='time-button-label libre-franklin-chart'>DAY</div>
            <StyledButton onClick={handleForwardClick} aria-label="forward">
                <CurvedRightArrow width='1rem' height='1rem' fill = 'rgb(77, 77, 77)' />  
            </StyledButton>
        </StyledContainer>
      

    </div>
    


    // if(isLoading){
    //     return <h3>Loading...</h3>
    // }

    // if(error){
    //     return <pre>{JSON.stringify(error)}</pre>
    // }



    // const { data, isLoading, isSuccess, mutate} = useMutation( 
        
    //     { 

    //     mutationFn: (delta: string) => 
    //         fetch('http://localhost:8000/' + {delta},{
    //             method: "POST",
    //             body: JSON.stringify(delta)
    //         })
    //     .then((res) => res.json())

    // });

    // if(isLoading){

    //     console.log("is Loading")
         // return <h3>Loading...</h3>
    // }
    // if(error){
    //     return <pre>{JSON.stringify(error)}</pre>
    // }
    // console.log(data)
    
}


